angular.module("ainapp")
    .controller("EarningDeductionListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Earnings & Deductions List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                    IsLinkPending: false,
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        //                        o.data.Keyword = $scope.filter.Keyword;
                        //                        o.data.IsLinkPending = $scope.filter.IsLinkPending;
                        MainService.EarningDeductionInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            "Employee.Name": {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            TotalDeduction: {
                                type: "number",
                            },
                            TotalEarning: {
                                type: "number",
                            },
                            Year: {
                                type: "number",
                            },
                            Month: {
                                type: "string",
                            },
                            "CreatedBy.UserName": {
                                type: "string",
                            },
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [
                    {
                        field: "VoucherNumber",
                        title: "#",
                    },
                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                    },
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                    },
                    {
                        field: "Year",
                        title: "Year",
                    },
                    {
                        field: "Month",
                        title: "Month",
                    },
                    {
                        field: "TotalEarning",
                        title: "Total Earning",
                    },
                    {
                        field: "TotalDeduction",
                        title: "Total Deduction",
                    },
                    {
                        field: "CreatedBy.UserName",
                        title: "Created By",
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button>",
                        width: '80px'
                    },


                                        ],
            };


            $scope.Edit = function (data) {
                $state.go("editEarningDeduction", {
                    VoucherId: data.Id
                })
            };

            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }


            $scope.Delete = function (data) {
                $scope.SelectedDataForDelete = data;
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEarningDeduction($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                    $scope.load = false;
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



                }])
